import http from "V2.0/services/httpService";

function getDomainIntegration({ workspaceId, assistantId }) {
  return http.get(
    `/v1/embedChat/whitelabelGetDomainIntegration/${workspaceId}/${assistantId}`
  );
}

function updateDomainIdentifiers({ workspaceId, assistantId, payload }) {
  return http.post(
    `/v1/embedChat/whitelabelWhitelistDomain/${workspaceId}/${assistantId}`,
    payload
  );
}

function createAndUpdateDomainIdentifier({
  workspaceId,
  assistantId,
  payload,
}) {
  return http.post(
    `/v1/embedChat/whitelabelCreateDomainIntegration/${workspaceId}/${assistantId}`,
    payload
  );
}

export {
  getDomainIntegration,
  updateDomainIdentifiers,
  createAndUpdateDomainIdentifier,
};
